import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface DashboardOperacaoGrupo {
  grupo_id: number;
  nome: string;
  total_estacoes: number;
  ativos: number;
  alertas: number;
  offline: number;
  percentual_ok: number;
}

export interface DashboardOperacaoHeatmapGrupo {
  grupo_id: number;
  nome: string;
  valores: Array<{ hora: number; total: number }>;
}

export interface DashboardOperacaoIntegracao {
  integrador_id: number;
  nome: string;
  tipo: string;
  total_integrado: number;
  total_coletado: number;
  taxa_sucesso: number;
  latencia_media_segundos: number;
}

export interface DashboardOperacaoTopEstacao {
  estacao_id: number;
  nome: string;
  total_mensagens: number;
}

export interface DashboardOperacaoAlerta {
  tipo: string;
  estacao_id?: number;
  estacao_nome?: string;
  integrador_id?: number;
  ultima_atividade: string;
  tempo_inativo?: string;
}

export interface DashboardOperacaoResponse {
  data: string;
  ultima_atualizacao: string;
  agrupamento?: 'grupo' | 'cliente' | 'coletor' | 'integrador';
  grupos: DashboardOperacaoGrupo[];
  heatmap: {
    grupos: DashboardOperacaoHeatmapGrupo[];
    pico: { hora: number; total: number };
    media_hora: number;
  };
  integracoes: DashboardOperacaoIntegracao[];
  top_estacoes: DashboardOperacaoTopEstacao[];
  alertas: DashboardOperacaoAlerta[];
}

@Injectable({
  providedIn: 'root'
})
export class DashboardOperacaoService {
  private readonly urlBase = environment.urlBase;

  constructor(private http: HttpClient) {}

  carregarDashboard(params: {
    data?: string;
    agrupamento?: 'grupo' | 'cliente' | 'coletor' | 'integrador';
    agrupamentoId?: number | null;
    grupoId?: number | null;
    clienteId?: number | null;
    coletorId?: number | null;
    integradorId?: number | null;
  }): Observable<DashboardOperacaoResponse> {
    let paramsHttp = new HttpParams();

    if (params.data) {
      paramsHttp = paramsHttp.set('data', params.data);
    }

    if (params.agrupamento) {
      paramsHttp = paramsHttp.set('agrupamento', params.agrupamento);
    }

    if (params.agrupamentoId) {
      paramsHttp = paramsHttp.set('agrupamento_id', params.agrupamentoId.toString());
    }

    if (params.grupoId) {
      paramsHttp = paramsHttp.set('grupo_id', params.grupoId.toString());
    }

    if (params.clienteId) {
      paramsHttp = paramsHttp.set('cliente_id', params.clienteId.toString());
    }

    if (params.coletorId) {
      paramsHttp = paramsHttp.set('coletor_id', params.coletorId.toString());
    }

    if (params.integradorId) {
      paramsHttp = paramsHttp.set('integrador_id', params.integradorId.toString());
    }

    return this.http.get<DashboardOperacaoResponse>(`${this.urlBase}/dashboards/operacional`, { params: paramsHttp });
  }
}
